/// <amd-module name="Environments/Providers/VirtualMachineGroups/Actions/VirtualMachineGroupActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { EnvironmentResourceReference, VirtualMachineGroup, PackageMetadata, TaskAgentPool, VirtualMachine } from "DistributedTask/Client/Contracts/TaskAgent";
import { IVirtualMachineGroupTargetsResult } from "Environments/Providers/VirtualMachineGroups/Services/VirtualMachineGroupExtendedClient";
import { IVirtualMachineTagsInfo } from "Environments/Providers/VirtualMachineGroups/Common/Utils";

export class VirtualMachineGroupActions extends ActionsHubBase {

    public static getKey(): string {
        return "virtualmachinegroup-actions";
    }

    public initialize(instanceId?: string) {
        this._setVirtualMachineGroup = new Action<VirtualMachineGroup>();
        this._setVirtualMachineGroupTargetsResult = new Action<IVirtualMachineGroupTargetsResult>();
        this._loadMoreVirtualMachineGroupTargetsResult = new Action<IVirtualMachineGroupTargetsResult>();
        this._setTargetPackages = new Action<PackageMetadata[]>();
        this._setTaskAgentPool = new Action<TaskAgentPool>();
        this._setPATForDeploymentPool = new Action<string>();
        this._onVirtualMachineTagUpdated = new Action<IVirtualMachineTagsInfo>();
        this._virtualMachinesUpdated = new Action<VirtualMachine[]>();
    }

    public get setVirtualMachineGroup() {
        return this._setVirtualMachineGroup;
    }

    public get setVirtualMachineGroupTargetsResult(): Action<IVirtualMachineGroupTargetsResult> {
        return this._setVirtualMachineGroupTargetsResult;
    }

    public get loadMoreVirtualMachineGroupTargetsResult(): Action<IVirtualMachineGroupTargetsResult> {
        return this._loadMoreVirtualMachineGroupTargetsResult;
    }

    public get setTargetPackages() {
        return this._setTargetPackages;
    }

    public get setTaskAgentPool() {
        return this._setTaskAgentPool;
    }

    public get setPATForDeploymentPool() {
        return this._setPATForDeploymentPool;
    }

    public get onVirtualMachineTagUpdated() {
        return this._onVirtualMachineTagUpdated;
    }

    public get onVirtualMachinesUpdated() {
        return this._virtualMachinesUpdated;
    }
    
    private _setVirtualMachineGroup: Action<VirtualMachineGroup>;
    private _setVirtualMachineGroupTargetsResult: Action<IVirtualMachineGroupTargetsResult>;
    private _loadMoreVirtualMachineGroupTargetsResult: Action<IVirtualMachineGroupTargetsResult>;
    private _setTargetPackages: Action<PackageMetadata[]>;
    private _setTaskAgentPool: Action<TaskAgentPool>;
    private _setPATForDeploymentPool: Action<string>;
    private _virtualMachinesUpdated: Action<VirtualMachine[]>;
    private _onVirtualMachineTagUpdated: Action<IVirtualMachineTagsInfo>;
}
